module.exports = __webpack_public_path__ + "media/Register_Promo_Code.bfb32d31.mp4";